<template>
	<div>
		<van-loading size="24px" vertical type="spinner" class="loading" color="#fff" v-if="isLoading">
			<img src="../assets/images/touxiang.png" width="36" />
			<br />数据加载中
		</van-loading>
		<div v-if="!isLoading">
			<div class="search-header">
				<div class="search-input shadow-down" @click="$router.push('/search')">
					您想住在哪儿？
					<span class="location">
						<van-icon name="location-o" size="16" />石柱
					</span>
				</div>
			</div>

			<van-swipe :autoplay="3000">
				<van-swipe-item>
					<van-image height="140" :src="note" width="100%" />
				</van-swipe-item>
			</van-swipe>
			<div>
				<van-swipe :show-indicators="false">
					<van-swipe-item>
						<ul class="menu-box">
							<li v-for="(item, index) in menus" :key="index" @click="$router.push(item.url)">
								<div class="index-menu">
									<img :src="item.icon" />
								</div>
								<p>{{ item.name }}</p>
							</li>
						</ul>
					</van-swipe-item>
				</van-swipe>
			</div>
			<!-- <div style="padding:0 15px"><img src="../assets/images/map.png" width="100%" style="border-radius:4px"
					@click="$router.push('/map/1')" /></div> -->
			<!-- <div class="box" v-if="agents.length > 0">
        <div class="box-t">
          <div class="box-t-1">推荐经纪人</div>
          <div class="box-t-2" @click="$router.push('/agent')">
            更多经纪人
            <van-icon name="arrow" size="12" />
          </div>
        </div>
        <div class="box-c">
          <div style="padding: 0 10px">
            <van-swipe :show-indicators="false" :loop="false" :width="100">
              <van-swipe-item v-for="(item, index) in agents" :key="index">
                <div class="squer">
                  <div
                    class="squer-box"
                    @click="$router.push('/agent/' + item.uid)"
                  >
                    <div class="avatar">
                      <img :src="item.thumbnail" v-if="item.thumbnail" />
                      <img src="../assets/images/touxiang.png" v-else />
                    </div>
                    <div class="info">
                      <h1>{{ item.nickname }}</h1>
                      <p class="com">{{ item.shopname }}</p>
                      <p class="info-btn">Ta的店铺</p>
                    </div>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </div>-->
<!-- 			<div class="box">
				<div class="box-t">
					<div class="box-t-1">新房 · 全城热门好盘</div>
					<div class="box-t-2" @click="$router.push('/house')">
						更多在售楼盘
						<van-icon name="arrow" size="12" />
					</div>
				</div>
				<div class="box-c">
					<div style="padding: 0 10px">
						<van-swipe :show-indicators="false" :loop="false" :width="loupanwidth">
							<van-swipe-item v-for="(item, index) in loupans" :key="index">
								<div class="bikan" @click="$router.push('/house/view/' + item.id)">
									<div class="bikan-img" :style="{
                      'background-size': '100% 90px',
                      'background-image': 'url(' + item.thumb + ')',
                      height: '90px',
                      width: '100%',
                    }"></div>
									<p class="bikan-t">{{ item.title }}</p>
								</div>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
			</div> -->
			<div class="blank" v-if="haofang.length > 0"></div> 
  			<div class="box" v-if="haofang.length > 0">
				<div class="box-t">
					<div class="box-t-1">
						二手房 · 全城必看<font color="#ff0000">好房</font>
					</div>
					<div class="box-t-2" @click="$router.push('/person')">
						石柱必看好房
						<van-icon name="arrow" size="12" />
					</div>
				</div>
				<div class="box-c">
					<div style="padding: 0 10px">
						<van-swipe :show-indicators="false" :loop="false" :width="120">
							<van-swipe-item v-for="(item, index) in haofang" :key="index">
								<div class="bikan" @click="$router.push('/ershoufang/view/' + item.id)">
									<div class="bikan-img" :style="{
                      'background-size': '100% 90px',
                      'background-image': 'url(' + item.thumbnail + ')',
                      height: '90px',
                      width: '100%',
                    }"></div>
									<p class="bikan-tag">
										{{ item.shi }}{{ item.ting }}/{{ item.area }}m²
									</p>
									<p class="bikan-xiaoqu">{{ item.community }}</p>
									<p class="bikan-price">
										{{ item.price ? item.price : "面议" }}{{ item.unit }}
									</p>
								</div>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
			</div>
			<div class="blank" v-if="jishou.length > 0"></div>
			<div class="box" v-if="jishou.length > 0">
				<div class="box-t">
					<div class="box-t-1">
						二手房 · 石柱<font color="#ff0000">急售</font>房源
					</div>
					<div class="box-t-2" @click="$router.push('/diy/2')">
						更多急售房源
						<van-icon name="arrow" size="12" />
					</div>
				</div>
				<div class="box-c">
					<div style="padding: 0 10px">
						<van-swipe :show-indicators="false" :loop="false" :width="120">
							<van-swipe-item v-for="(item, index) in jishou" :key="index">
								<div class="bikan" @click="$router.push('/ershoufang/view/' + item.id)">
									<div class="bikan-img" :style="{
                      'background-size': '100% 90px',
                      'background-image': 'url(' + item.thumbnail + ')',
                      height: '90px',
                      width: '100%',
                    }"></div>
									<p class="bikan-tag">
										{{ item.shi }}{{ item.ting }}/{{ item.area }}m²
									</p>
									<p class="bikan-xiaoqu">{{ item.community }}</p>
									<p class="bikan-price">
										{{ item.price ? item.price : "面议" }}{{ item.unit }}
									</p>
								</div>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
			</div>

			<div class="blank"></div>
			<div class="tongji-box">
				<van-row gutter="15">
					<van-col span="6">
						<div class="tongji">
							<p>
								<font color="#5cc55c">{{ views }}</font>
								<!-- <span>w</span> -->
							</p>
							<span>昨日浏览量</span>
						</div>
					</van-col>
					<van-col span="6">
						<div class="tongji">
							<p>
								<font color="#f74c31">{{ ernumber }}</font>
								<span>套</span>
							</p>
							<span>二手房</span>
						</div>
					</van-col>
					<van-col span="6">
						<div class="tongji">
							<p>
								<font color="#68a6d5">{{ zfnumber }}</font>
								<span>套</span>
							</p>
							<span>租房</span>
						</div>
					</van-col>
					<van-col span="6">
						<div class="tongji">
							<p>
								<font color="#fb9031">{{ agentnumber }}</font>
								<span>套</span>
							</p>
							<span>商铺</span>
						</div>
					</van-col>
				</van-row>
			</div>

			<div class="blank"></div>

			<van-tabs v-model="active">
				<van-tab title="租房">
					<div class="houselist">
						<ul>
							<li v-for="(item, index) in zufang" :key="index"
								@click="$router.push('/zufang/view/' + item.id)">
								<div class="img">
									<div class="top" v-if="item.stick"></div>
									<div class="zhongjie" v-if="item.isagent && item.ismy">
										房小柒
									</div>
									<div class="zhongjie" v-else-if="item.isagent && !item.ismy">
										中介
									</div>
									<div class="geren" v-else>个人</div>
									<img :src="item.thumbnail" />
								</div>
								<div class="info">
									<h1>
										{{ item.title }}
										{{ item.price ? item.price + item.unit : "面议" }}
									</h1>
									<p class="tag">
										<van-tag color="#ecf3fe" text-color="#6e86b1" v-for="(v, i) in item.peitao"
											:key="i" v-if="i < 3">{{ v }}</van-tag>
									</p>
									<div class="pflex">
										<p class="txt2">
											{{ item.shi }}{{ item.ting }} | {{ item.community }}
										</p>
										<p class="txt1">
											{{ item.price ? item.price : "面议" }}
											<small v-if="item.price">{{ item.unit }}</small>
										</p>
									</div>
								</div>
							</li>
						</ul>
						<div class="houselist-b" @click="$router.push('zufang')">
							查看更多租房
						</div>
					</div>
				</van-tab>
				<van-tab title="二手房">
					<div class="houselist">
						<ul>
							<li v-for="(item, index) in ershoufang" :key="index"
								@click="$router.push('/ershoufang/view/' + item.id)">
								<div class="img">
									<!-- <div class="top" v-if="item.stick"></div>
                  <div class="zhongjie" v-if="item.isagent && item.ismy">房小柒</div>
                  <div class="zhongjie" v-else-if="item.isagent && !item.ismy">中介</div>

                  <div class="geren" v-if="!item.isagent">个人</div>-->
									<img :src="item.thumbnail" />
								</div>
								<div class="info">
									<h1>
										{{ item.title }}
										{{ item.price ? item.price + item.unit : "面议" }}
									</h1>
									<p class="tag">
										<van-tag color="#ecf3fe" text-color="#6e86b1" v-for="(v, i) in item.tese"
											:key="i" v-if="i < 3">{{ v }}</van-tag>
									</p>
									<div class="pflex">
										<p class="txt2">
											{{ item.shi }}{{ item.ting }} | {{ item.community }}
										</p>
										<p class="txt1">
											{{ item.price ? item.price : "面议" }}
											<small v-if="item.price">{{ item.unit }}</small>
										</p>
									</div>
									<div class="">
										<p class="txt2">{{ item.refreshtime }}</p>
									</div>
								</div>
							</li>
						</ul>
						<div class="houselist-b" @click="$router.push('ershoufang')">
							查看更多二手房
						</div>
					</div>
				</van-tab>
				<van-tab title="商铺">
					<div class="houselist">
						<ul>
							<li v-for="(item, index) in shop" :key="index"
								@click="$router.push('/shop/view/' + item.id)">
								<div class="img">
									<div class="top" v-if="item.stick"></div>
									<!-- <div class="zhongjie" v-if="item.isagent && item.ismy">房小二</div>
                  <div class="zhongjie" v-else-if="item.isagent && !item.ismy">中介</div>

                  <div class="geren" v-if="!item.isagent">个人</div>-->
									<img :src="item.thumbnail" />
								</div>
								<div class="info">
									<h1>{{ item.title }}</h1>
									<p class="tag">
										<van-tag color="#ecf3fe" text-color="#6e86b1" v-for="(v, i) in item.tese"
											:key="i" v-if="i < 3">{{ v }}</van-tag>
									</p>
									<div class="pflex">
										<p class="txt1">
											{{ item.price ? item.price : "面议" }}
											<small v-if="item.price">{{ item.unit }}</small>
										</p>
										<p class="txt2">{{ item.refreshtime }}</p>
									</div>
								</div>
							</li>
						</ul>
						<div class="houselist-b" @click="$router.push('shop')">
							查看更多商铺
						</div>
					</div>
				</van-tab>
			</van-tabs>

			<footbar />
		</div>
	</div>
</template>

<script>
	var root = process.env.VUE_APP_API_URL;
	import Footbar from "./commpents/footbar";

	import {
		Tabbar,
		TabbarItem,
		Grid,
		GridItem,
		Image,
		Tag,
		Row,
		Col,
		Button,
		NoticeBar,
		Tab,
		Tabs,
		Swipe,
		SwipeItem,
		Icon,
		PullRefresh,
		Loading,
	} from "vant";

	export default {
		components: {
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Image.name]: Image,
			[Tag.name]: Tag,
			[Row.name]: Row,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Col.name]: Col,
			[Button.name]: Button,
			[NoticeBar.name]: NoticeBar,
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[Icon.name]: Icon,
			[PullRefresh.name]: PullRefresh,
			[Loading.name]: Loading,
			Footbar,
		},

		data() {
			return {
				getInitUrl: root + "default/index",
				getZufangUrl: root + "default/zufang",
				getErshoufangUrl: root + "default/ershoufang",
				getShopUrl: root + "default/shop",
				getLoupanUrl: root + "default/loupan",
				getJishouUrl: root + "default/jishou",
				getHaofangUrl: root + "default/haofang",
				zfnumber: 0,
				ernumber: 0,
				agentnumber: 0,
				clicks: 0,
				menus: [],
				note: "",
				zufang: [],
				ershoufang: [],
				shop: [],
				agents: [],
				loupans: [],
				diys: [],
				jishou: [],
				haofang: [],
				active: 0,
				width: 200,
				loupanwidth: 100,
				type: "zufang",
				isLoading: true,
			};
		},
		computed: {
			views: function() {
				// if (this.clicks > 10000) {
				// 	return (this.clicks / 10000).toFixed(1);
				// } else {
				// 	return this.clicks;
				// }
				return this.clicks;
			},
		},
		mounted() {
			this.init();
			this.width = (document.body.clientWidth - 100) / 2;
			this.loupanwidth = (document.body.clientWidth - 20) / 3;
			document.title = "石柱房产网";
			this.getZufang()
			this.getLoupan()
			this.getJishou()
			this.getHaofang()
			this.getErshoufang()
			this.getShop()
			
		},

		methods: {
			init() {
				var self = this;
				$.ajax({
					url: self.getInitUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						console.log(reponseData.data);
						//self.lists = reponseData.data.lists;
						self.note = reponseData.data.note;
						self.agents = reponseData.data.agents;
						self.zfnumber = reponseData.data.zufangs;
						self.ernumber = reponseData.data.ershoufangs;
						self.agentnumber = reponseData.data.agentnumber;
						self.clicks = reponseData.data.clicks;
						self.menus = reponseData.data.menus;
						self.diys = reponseData.data.diys;
						//self.jishou = reponseData.data.jishou;
						//self.haofang = reponseData.data.haofang;
						//self.loupans = reponseData.data.loupans;
						self.Share();
						self.isLoading = false;

					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			getZufang() {
				var self = this;
				$.ajax({
					url: self.getZufangUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.zufang = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			getErshoufang() {
				var self = this;
				$.ajax({
					url: self.getErshoufangUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.ershoufang = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			getShop() {
				var self = this;
				$.ajax({
					url: self.getShopUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.shop = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			getLoupan(){
				var self = this;
				$.ajax({
					url: self.getLoupanUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.loupans = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			getJishou(){
				var self = this;
				$.ajax({
					url: self.getJishouUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.jishou = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			getHaofang(){
				var self = this;
				$.ajax({
					url: self.getHaofangUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.haofang = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			onRefresh() {
				this.init();
			},
			Share() {
				var title = "石柱房产网-买房.卖房.租房-找石柱生活网帮忙！";
				var description =
					"提供石柱县新楼盘、二手房、租房、商铺；房屋买卖，找石柱生活网房小二帮忙！";
				var avatar = "http://fc.45win.com/house/web/images/logo.png";
				var url = window.location.href;
				this.setShare(title, description, url, avatar);
			},
		},
	};
</script>

<style scoped>
	.squer {
		padding: 0 5px;
	}

	.squer-box {
		border: #f8f8f8 1px solid;
		border-radius: 4px;
		padding: 5px 10px;
		background-color: #f8f8f8;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.squer-box .avatar {
		width: 45px;
		height: 45px;
		border-radius: 100%;
	}

	.squer-box .avatar img {
		width: 45px;
		height: 45px;
		border-radius: 100%;
	}

	.squer-box .info {
		text-align: center;
	}

	.squer-box-icon1 {
		background-image: url("../assets/images/squer2.png");
		background-repeat: no-repeat;
		background-size: 24px;
		background-position: 90% 75%;
	}

	.squer-box-icon2 {
		background-image: url("../assets/images/squer1.png");
		background-repeat: no-repeat;
		background-size: 24px;
		background-position: 90% 75%;
	}

	.squer-box h1 {
		font-size: 14px;
	}

	.squer-box p.com {
		color: #9a9a9a;
		font-size: 12px;
		padding: 5px 0;
	}

	.squer-box p.info-btn {
		border: #f5662a 1px solid;
		border-radius: 50px;
		color: #f5662a;
		font-size: 9px;
		padding: 0 8px;
	}
</style>>